/** 聊天记录保留期提示；天数与后端 Support.MessageRetentionDays（默认 14）一致，改天数时两边一起改。 */
export const RETENTION_NOTICE = '聊天记录最多保留 14 天，如有需要请提前备份。';
